export default {
  FromDad: 1,
  FromMom: 2,
  FromGuardian: 3,
}
